import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { label } from '../constants/labels';

@Component({
  selector: 'app-haccpReport',
  standalone: false,
  templateUrl: './haccp-reports.component.html',
  styleUrls: ['./haccp-reports.component.scss']
})
export class HaccpReportsComponent implements OnInit, OnDestroy {
  activeTabIndex = 0;
  labels: any;
  private sub?: Subscription;

  constructor(private readonly router: Router, private readonly route: ActivatedRoute) {}

  ngOnInit() {
    this.labels = label;
    this.syncTabWithUrl(this.router.url);

    this.sub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => this.syncTabWithUrl((event as NavigationEnd).urlAfterRedirects));
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
    const route = this.getRouteForTabIndex(this.activeTabIndex);
    if (route) {
      this.router.navigate([route], { relativeTo: this.route });
    }
  }

  private getRouteForTabIndex(index: number): string | null {
    switch (index) {
      case 0:
        return 'hccp-dashboard';
      case 1:
        return 'create-report';
      default:
        return null;
    }
  }

  private syncTabWithUrl(url: string) {
    this.activeTabIndex = url.includes('/create-report') ? 1 : 0;
  }
}
